import { openToast } from "../utils/utils";

export function Copyable({ str }: { str: string }) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        navigator.clipboard.writeText(str);
        openToast("success", <div>Texte copié avec succès</div>, null, 2000);
      }}
    >
      {str}
    </div>
  );
}
